import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const PinterestPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Pinterest"
      description="Step-by-step instructions for adding your Upfeed product feed to Pinterest Catalogs to run Shopping Ads and dynamic Product Pins."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Pinterest</Pagetitle>
          <p>
            Follow these steps to connect your UpFeed product feed to Pinterest
            Catalogs so you can run Shopping Ads and create dynamic Product
            Pins.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>
                <Link to="/getting-started/#googlecats">
                  Set your Google Product Categories
                </Link>{" "}
                — required for Pinterest.
              </li>
            </ul>
          </div>

          <h2>Adding the feed to Pinterest</h2>
          <ul>
            <li>Copy the product feed URL from the app homepage.</li>
            <li>In Pinterest go to Ads &gt; Catalogs.</li>
            <li>
              Click 'Get Started' then 'Add Datasource' and paste the product
              feed URL.
            </li>
            <li>
              Select 'CSV' as the file format and click the 'Create Pins' button
              to upload your feed to Pinterest.
            </li>
          </ul>

          <h2>Running Shopping Ads</h2>
          <p>
            Once your catalog is approved and your products are live, go to Ads
            &gt; Create Campaign and choose 'Shopping' or 'Consideration' as
            your campaign objective to start running dynamic Product Ads.
          </p>

          <RelatedPlatforms currentSlug="pinterest" />
        </div>
      </div>
    </div>
  </Layout>
)

export default PinterestPage
